import { Injectable } from '@angular/core';
import { SessionService } from '.';

@Injectable({
    providedIn: 'root',
  })
  export class InternationalizationService {
    reportedIds = new Set<string>();

    constructor(
        public sessionService: SessionService
    ) {
    }

    public str(id: string, text: string): () => string {
        let s = this.sessionService.translations?.[id];

        if (s === undefined || s === '') {
            // s = "[missing:" + id + "]";
            s = text;
            if (!!this.sessionService.translations && !this.reportedIds.has(id)) {
                this.reportedIds.add(id);
                console.error("missing string with id " + id);
            }
        }
        return () => s;
    }
}
